import COLORS from '../theme/colors';

const colorOptions = Object.entries(COLORS).reduce((agg, curr) => {
  const [key, val] = curr;
  const colorPallete = Object.keys(val).map(i => `${key}.${i}`);

  return [...agg, ...colorPallete];
}, []);

export default colorOptions;
